import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as ApexCharts from 'apexcharts';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';


import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
	selector: 'app-advisor-book-optimise',
	templateUrl: './advisor-book-optimise.component.html',
	styleUrls: ['./advisor-book-optimise.component.scss']
})
export class AdvisorBookOptimiseComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
	) { }

	user_details: any;

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");
		this.getPageData();
	}

	@Input() show_recommendations_explanation: any;
	@Input() page_type: any;
	@Input() advisor_details: any;

	// Adjust
	// Confirm
	// Individual (In Executive Module to show Individual Advisor Details)

	page_data: any;
	page_data_loaded: boolean = false;
	getPageData() {
		this.page_data_loaded = false;
		let route: any = "";

		if (this.page_type == 'Adjust') {
			route = "/optimizerecommendationsummary/";
		} else if (this.page_type == 'Confirm') {
			route = "/reviewrecommendationsummary/";
		} else if (this.page_type == 'Performance') {
			route = "/performancemeasurementsummary/";
		} else if (this.page_type == 'Individual') {
			route = "/optimizerecommendationsummary/?advisor_id=" + this.advisor_details.id;
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_data = res["data"];
				this.page_data_loaded = true;

				setTimeout(() => {

					const targetElement = document.getElementById('page-body');
					if (targetElement) {
						targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}

					this.createSummaryBookGraph();

					this.createIncreaseFoucsAUMGraph(this.page_data['increase_focus_incremental_graph']);
					this.createDelegateMAGIAUMGraph(this.page_data['agi_incremental_graph']);
					this.createDelegateAFAAUMGraph(this.page_data['afa_incremental_graph']);

					this.createIncreaseFoucsRiskGraph();
					this.createDelegateMAGIRiskGraph();
					this.createDelegateAFARiskGraph();

					this.createIncreaseFoucsEngagementGraph();
					this.createDelegateMAGIEngagementGraph();
					this.createDelegateAFAEngagementGraph();
				}, 200);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		k < 1
		? num.toFixed(0 + fixed)
		: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	@Output() stepperChange = new EventEmitter<any>();
	navigateToStep(step) {
		this.stepperChange.emit(step);
	}

	createSummaryBookGraph() {
		let $this = this;

		const options = {
			colors: $this.page_data["total_clients_graph"]['colors'],
			series: $this.page_data["total_clients_graph"]['data'],
			chart: {
				type: 'donut',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 180,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_data["total_clients_graph"]['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
				show: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#summary-graph'), options);
		chart.render();
	}

	scrollToView() {
		const targetElement = document.getElementById('scrollble-body');
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	analysis_value: any = "";
	analysis_value_filter: any = "";
	analysis_data: any;
	analysis_data_loaded: boolean = false;

	showRecommendations(state, filter) {
		this.analysis_data_loaded = false;
		this.analysis_value = "";
		this.analysis_value_filter = "";
		setTimeout(() => {
			this.analysis_value = state;
			this.analysis_value_filter = filter;
			this.analysis_data_loaded = true;
			this.scrollToView();
		}, 200);
	}

	increase_foucs_aum_graph: any;
	increase_foucs_aum_graph_options: any;
	increase_foucs_aum_slider_value: any =  10;
	createIncreaseFoucsAUMGraph(actual_data) {

		let data = JSON.parse(JSON.stringify(actual_data));

		let graph_data;

		if (this.page_type == 'Performance') {
			graph_data = data['y-axis'];
		} else {
			const series_data = data['y-axis'];

			// Line Graph
			// series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.increase_foucs_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.increase_foucs_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.increase_foucs_aum_slider_value/100));

			series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.increase_foucs_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.increase_foucs_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.increase_foucs_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 4] = (series_data[3]['data'][series_data[3]['data'].length - 4] * (this.increase_foucs_aum_slider_value/100));

			graph_data = series_data;

			// if (this.page_type == 'Adjust') {
			// 	series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.increase_foucs_aum_slider_value/100));
			// 	graph_data = series_data;
			// } else {
			// 	series_data[2]['data'][series_data[2]['data'].length - 1] = (series_data[2]['data'][series_data[2]['data'].length - 1] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 2] = (series_data[2]['data'][series_data[2]['data'].length - 2] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 3] = (series_data[2]['data'][series_data[2]['data'].length - 3] * (this.increase_foucs_aum_slider_value/100));

			// 	series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.increase_foucs_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.increase_foucs_aum_slider_value/100));

			// 	graph_data = series_data;
			// }
		}

		let $this = this;

		if ($this.increase_foucs_aum_graph) {
			$this.increase_foucs_aum_graph.destroy();
		}

		// let options = {
		$this.increase_foucs_aum_graph_options = {
			// Line Graph
			// colors: $this.page_data['increase_focus_incremental_graph']['colors'],
			// series: $this.page_data['increase_focus_incremental_graph']['y-axis'],

			// colors: data['colors'],
			// series: data['y-axis'],
			// chart: {
			// 	height: 200,
			// 	type: 'line',
			// 	toolbar: {
			// 		show: false,
			// 	},
			// 	zoom: {
			// 		nabled: false,
			// 	},
			// },
			// noData: {
			// 	text: 'No Data Available',
			// 	align: 'center',
			// 	verticalAlign: 'middle',
			// 	offsetX: 0,
			// 	offsetY: 0,
			// 	style: {
			// 		color: '#006AFF',
			// 		fontSize: '24px',
			// 		fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			// 	},
			// },
			// stroke: {
			// 	curve: 'smooth',
			// 	width: 1,
			// },
			// fill: {
			// 	type: 'solid',
			// 	opacity: [1, 1],
			// },
			// forecastDataPoints: {
			// 	count: 3,
			// 	fillOpacity: 0.5,
			// 	strokeWidth: 1,
			// 	dashArray: 4,
			// },
			// // labels: $this.page_data['increase_focus_incremental_graph']['x-axis'],
			// labels: data['x-axis'],
			// markers: {
			// 	size: 0,
			// },
			// yaxis: [
			// 	{
			// 		title: {
			// 			// text: '',
			// 		},
			// 		labels: {
			// 			formatter: function (value) {
			// 				let val: string | number = Math.abs(value);
			// 				if (val >= 10 ** 3 && val < 10 ** 6) {
			// 					val = (val / 1000).toFixed(0) + 'K';
			// 				} else if (val >= 10 ** 6) {
			// 					val = (val / 1000000).toFixed(1) + 'M';
			// 				} else {
			// 					val = val;
			// 				}
			// 				return val;
			// 			},

          // formatter: (value: number) => {
          //   return this.commonService.labelFormatter(value);
          // }
			// 		},
			// 	},
			// ],

			// Stacked Bar Graph
			colors: data['colors'],
			series: data['y-axis'],
			chart: {
				type: 'bar',
					toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
				stacked: true,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("increase-focus-aum-graph").clientWidth,
						 data['x-axis'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: data['x-axis'],
				// title: {
				// 	text: 'Year'
				// },
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: true,
					// formatter: function (value) {
					// 	let val: string | number = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(0) + 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1) + 'M';
					// 	} else {
					// 		val = val;
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
				title: {
					// text: 'Count'
				},
			},
			fill: {
				opacity: 1,
        type: ['solid', 'pattern', 'solid', 'pattern'],
        pattern: {
          style: ['slantedLines', 'slantedLines', 'slantedLines', 'slantedLines'], // Patterns for forecasted data
          width: 5,
          height: 5,
          strokeWidth: 1
        }
			},
			// tooltip: {
			// 	custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			// 		return ('<div style="padding:8px">' +
			// 			$this.page_data["increase_focus_incremental_graph"]['x-axis'][dataPointIndex] + ": " + data['y-axis'][dataPointIndex] +
			// 			'</div>')
			// 	}
			// }

		};


		// var chart = new ApexCharts(document.querySelector('#increase-focus-aum-graph'), options);
		$this.increase_foucs_aum_graph = new ApexCharts(document.querySelector('#increase-focus-aum-graph'), $this.increase_foucs_aum_graph_options);
		$this.increase_foucs_aum_graph.render();
	}

	delegate_agi_aum_graph: any;
	delegate_agi_aum_graph_options: any;
	delegate_agi_aum_slider_value: any =  10;
	createDelegateMAGIAUMGraph(actual_data) {

		let data = JSON.parse(JSON.stringify(actual_data));

		let graph_data;

		if (this.page_type == 'Performance') {
			graph_data = data['y-axis'];
		} else {
			const series_data = data['y-axis'];

			// Line Graph
			// series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.delegate_agi_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.delegate_agi_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.delegate_agi_aum_slider_value/100));

			series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.delegate_agi_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.delegate_agi_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.delegate_agi_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 4] = (series_data[3]['data'][series_data[3]['data'].length - 4] * (this.delegate_agi_aum_slider_value/100));

			graph_data = series_data;

			// if (this.page_type == 'Adjust') {
			// 	series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.delegate_agi_aum_slider_value/100));
			// 	graph_data = series_data;
			// } else {
			// 	series_data[2]['data'][series_data[2]['data'].length - 1] = (series_data[2]['data'][series_data[2]['data'].length - 1] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 2] = (series_data[2]['data'][series_data[2]['data'].length - 2] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 3] = (series_data[2]['data'][series_data[2]['data'].length - 3] * (this.delegate_agi_aum_slider_value/100));

			// 	series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.delegate_agi_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.delegate_agi_aum_slider_value/100));

			// 	graph_data = series_data;
			// }
		}

		let $this = this;

		if ($this.delegate_agi_aum_graph) {
			$this.delegate_agi_aum_graph.destroy();
		}

		// let options = {
		$this.delegate_agi_aum_graph_options = {
			// Line Graph
			// colors: $this.page_data['agi_incremental_graph']['colors'],
			// series: $this.page_data['agi_incremental_graph']['y-axis'],

			// colors: data['colors'],
			// series: graph_data,
			// chart: {
			// 	height: 200,
			// 	type: 'line',
			// 	toolbar: {
			// 		show: false,
			// 	},
			// 	zoom: {
			// 		nabled: false,
			// 	},
			// },
			// noData: {
			// 	text: 'No Data Available',
			// 	align: 'center',
			// 	verticalAlign: 'middle',
			// 	offsetX: 0,
			// 	offsetY: 0,
			// 	style: {
			// 		color: '#006AFF',
			// 		fontSize: '24px',
			// 		fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			// 	},
			// },
			// stroke: {
			// 	curve: 'smooth',
			// 	width: 1,
			// },
			// fill: {
			// 	type: 'solid',
			// 	opacity: [1, 1],
			// },
			// forecastDataPoints: {
			// 	count: 3,
			// 	fillOpacity: 0.5,
			// 	strokeWidth: 1,
			// 	dashArray: 4,
			// },
			// // labels: $this.page_data['agi_incremental_graph']['x-axis'],
			// labels: data['x-axis'],
			// markers: {
			// 	size: 0,
			// },
			// yaxis: [
			// 	{
			// 		title: {
			// 			// text: '',
			// 		},
			// 		labels: {
			// 			formatter: function (value) {
			// 				let val: string | number = Math.abs(value);
			// 				if (val >= 10 ** 3 && val < 10 ** 6) {
			// 					val = (val / 1000).toFixed(0) + 'K';
			// 				} else if (val >= 10 ** 6) {
			// 					val = (val / 1000000).toFixed(1) + 'M';
			// 				} else {
			// 					val = val;
			// 				}
			// 				return val;
			// 			},
          // formatter: (value: number) => {
          //   return this.commonService.labelFormatter(value);
          // }
			// 		},
			// 	},
			// ],

			// Stacked Bar Graph
			colors: data['colors'],
			series: data['y-axis'],
			chart: {
				type: 'bar',
					toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
				stacked: true,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("delegate-agi-aum-graph").clientWidth,
						 data['x-axis'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: data['x-axis'],
				// title: {
				// 	text: 'Year'
				// },
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: true,
					// formatter: function (value) {
					// 	let val: string | number = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(0) + 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1) + 'M';
					// 	} else {
					// 		val = val;
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
				title: {
					// text: 'Count'
				},
			},
			fill: {
				opacity: 1,
        type: ['solid', 'pattern', 'solid', 'pattern'],
        pattern: {
          style: ['slantedLines', 'slantedLines', 'slantedLines', 'slantedLines'], // Patterns for forecasted data
          width: 5,
          height: 5,
          strokeWidth: 1
        }
			},
			// tooltip: {
			// 	custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			// 		return ('<div style="padding:8px">' +
			// 			$this.page_data["agi_incremental_graph"]['x-axis'][dataPointIndex] + ": " + data['y-axis'][dataPointIndex] +
			// 			'</div>')
			// 	}
			// }

		};


		// Bar & Line Graph

		// var chart = new ApexCharts(document.querySelector('#delegate-agi-aum-graph'), options);
		$this.delegate_agi_aum_graph = new ApexCharts(document.querySelector('#delegate-agi-aum-graph'), $this.delegate_agi_aum_graph_options);
		$this.delegate_agi_aum_graph.render();
	}

	delegate_afa_aum_graph: any;
	delegate_afa_aum_graph_options: any;
	delegate_afa_aum_slider_value: any =  10;
	createDelegateAFAAUMGraph(actual_data) {

		let data = JSON.parse(JSON.stringify(actual_data));

		let graph_data;

		if (this.page_type == 'Performance') {
			graph_data = data['y-axis'];
		} else {
			const series_data = data['y-axis'];

			// Line Graph
			// series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.delegate_afa_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.delegate_afa_aum_slider_value/100));
			// series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.delegate_afa_aum_slider_value/100));

			series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.delegate_afa_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.delegate_afa_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.delegate_afa_aum_slider_value/100));
			series_data[3]['data'][series_data[3]['data'].length - 4] = (series_data[3]['data'][series_data[3]['data'].length - 4] * (this.delegate_afa_aum_slider_value/100));

			graph_data = series_data;

			// if (this.page_type == 'Adjust') {
			// 	series_data[1]['data'][series_data[1]['data'].length - 1] = (series_data[1]['data'][series_data[1]['data'].length - 1] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 2] = (series_data[1]['data'][series_data[1]['data'].length - 2] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[1]['data'][series_data[1]['data'].length - 3] = (series_data[1]['data'][series_data[1]['data'].length - 3] * (this.delegate_afa_aum_slider_value/100));
			// 	graph_data = series_data;
			// } else {
			// 	series_data[2]['data'][series_data[2]['data'].length - 1] = (series_data[2]['data'][series_data[2]['data'].length - 1] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 2] = (series_data[2]['data'][series_data[2]['data'].length - 2] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[2]['data'][series_data[2]['data'].length - 3] = (series_data[2]['data'][series_data[2]['data'].length - 3] * (this.delegate_afa_aum_slider_value/100));

			// 	series_data[3]['data'][series_data[3]['data'].length - 1] = (series_data[3]['data'][series_data[3]['data'].length - 1] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 2] = (series_data[3]['data'][series_data[3]['data'].length - 2] * (this.delegate_afa_aum_slider_value/100));
			// 	series_data[3]['data'][series_data[3]['data'].length - 3] = (series_data[3]['data'][series_data[3]['data'].length - 3] * (this.delegate_afa_aum_slider_value/100));

			// 	graph_data = series_data;
			// }
		}

		let $this = this;

		if ($this.delegate_afa_aum_graph) {
			$this.delegate_afa_aum_graph.destroy();
		}

		// let options = {
		$this.delegate_afa_aum_graph_options = {

			// Line Graph
			// colors: $this.page_data['afa_incremental_graph']['colors'],
			// series: $this.page_data['afa_incremental_graph']['y-axis'],

			// colors: data['colors'],
			// series: graph_data,
			// chart: {
			// 	height: 200,
			// 	type: 'line',
			// 	toolbar: {
			// 		show: false,
			// 	},
			// 	zoom: {
			// 		nabled: false,
			// 	},
			// },
			// noData: {
			// 	text: 'No Data Available',
			// 	align: 'center',
			// 	verticalAlign: 'middle',
			// 	offsetX: 0,
			// 	offsetY: 0,
			// 	style: {
			// 		color: '#006AFF',
			// 		fontSize: '24px',
			// 		fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			// 	},
			// },
			// stroke: {
			// 	curve: 'smooth',
			// 	width: 1,
			// },
			// fill: {
			// 	type: 'solid',
			// 	opacity: [1, 1],
			// },
			// forecastDataPoints: {
			// 	count: 3,
			// 	fillOpacity: 0.5,
			// 	strokeWidth: 1,
			// 	dashArray: 4,
			// },
			// // labels: $this.page_data['afa_incremental_graph']['x-axis'],
			// labels: data['x-axis'],
			// markers: {
			// 	size: 0,
			// },
			// yaxis: [
			// 	{
			// 		title: {
			// 			// text: '',
			// 		},
			// 		labels: {
			// 			formatter: function (value) {
			// 				let val: string | number = Math.abs(value);
			// 				if (val >= 10 ** 3 && val < 10 ** 6) {
			// 					val = (val / 1000).toFixed(0) + 'K';
			// 				} else if (val >= 10 ** 6) {
			// 					val = (val / 1000000).toFixed(1) + 'M';
			// 				} else {
			// 					val = val;
			// 				}
			// 				return val;
			// 			},
          // formatter: (value: number) => {
          //   return this.commonService.labelFormatter(value);
          // }
			// 		},
			// 	},
			// ],

			// Stacked Bar Graph
			colors: data['colors'],
			series: data['y-axis'],
			chart: {
				type: 'bar',
					toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 300,
				stacked: true,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("delegate-afa-aum-graph").clientWidth,
						 data['x-axis'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: data['x-axis'],
				// title: {
				// 	text: 'Year'
				// },
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: true,
					// formatter: function (value) {
					// 	let val: string | number = Math.abs(value);
					// 	if (val >= 10 ** 3 && val < 10 ** 6) {
					// 		val = (val / 1000).toFixed(0) + 'K';
					// 	} else if (val >= 10 ** 6) {
					// 		val = (val / 1000000).toFixed(1) + 'M';
					// 	} else {
					// 		val = val;
					// 	}
					// 	return val;
					// },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
				},
				title: {
					// text: 'Count'
				},
			},
			fill: {
				opacity: 1,
        type: ['solid', 'pattern', 'solid', 'pattern'],
        pattern: {
          style: ['slantedLines', 'slantedLines', 'slantedLines', 'slantedLines'], // Patterns for forecasted data
          width: 5,
          height: 5,
          strokeWidth: 1
        }
			},
			// tooltip: {
			// 	custom: function ({ series, seriesIndex, dataPointIndex, w }) {
			// 		return ('<div style="padding:8px">' +
			// 			$this.page_data["agi_incremental_graph"]['x-axis'][dataPointIndex] + ": " + data['y-axis'][dataPointIndex] +
			// 			'</div>')
			// 	}
			// }

		};
		// var chart = new ApexCharts(document.querySelector('#delegate-afa-aum-graph'), options);
		$this.delegate_afa_aum_graph = new ApexCharts(document.querySelector('#delegate-afa-aum-graph'), $this.delegate_afa_aum_graph_options);
		$this.delegate_afa_aum_graph.render();
	}

	incremental_aum_slider_value: any = 10;

	createIncreaseFoucsRiskGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['increase_focus_retention_graph']['colors'],
			series: $this.page_data['increase_focus_retention_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['increase_focus_retention_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#increase-focus-risk-graph'), options);
		chart.render();
	}

	createDelegateMAGIRiskGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['agi_retention_graph']['colors'],
			series: $this.page_data['agi_retention_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['agi_retention_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#delegate-agi-risk-graph'), options);
		chart.render();
	}

	createDelegateAFARiskGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['afa_retention_graph']['colors'],
			series: $this.page_data['afa_retention_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['afa_retention_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#delegate-afa-risk-graph'), options);
		chart.render();
	}

	createIncreaseFoucsEngagementGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['increase_focus_client_engagement_graph']['colors'],
			series: $this.page_data['increase_focus_client_engagement_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['increase_focus_client_engagement_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#increase-focus-engagement-graph'), options);
		chart.render();
	}

	createDelegateMAGIEngagementGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['agi_client_engagement_graph']['colors'],
			series: $this.page_data['agi_client_engagement_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['agi_client_engagement_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#delegate-agi-engagement-graph'), options);
		chart.render();
	}

	createDelegateAFAEngagementGraph() {
		let $this = this;
		let options = {
			colors: $this.page_data['afa_client_engagement_graph']['colors'],
			series: $this.page_data['afa_client_engagement_graph']['y-axis'],
			chart: {
				height: 200,
				type: 'line',
				toolbar: {
					show: false,
				},
				zoom: {
					nabled: false,
				},
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			stroke: {
				curve: 'smooth',
				width: 1,
			},
			fill: {
				type: 'solid',
				opacity: [1, 1],
			},
			forecastDataPoints: {
				count: 3,
				fillOpacity: 0.5,
				strokeWidth: 1,
				dashArray: 4,
			},
			labels: $this.page_data['afa_client_engagement_graph']['x-axis'],
			markers: {
				size: 0,
			},
			yaxis: [
				{
					title: {
						// text: '',
					},
					labels: {
						// formatter: function (value) {
						// 	let val: string | number = Math.abs(value);
						// 	if (val >= 10 ** 3 && val < 10 ** 6) {
						// 		val = (val / 1000).toFixed(0) + 'K';
						// 	} else if (val >= 10 ** 6) {
						// 		val = (val / 1000000).toFixed(1) + 'M';
						// 	} else {
						// 		val = val;
						// 	}
						// 	return val;
						// },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
					},
				},
			],
		};
		var chart = new ApexCharts(document.querySelector('#delegate-afa-engagement-graph'), options);
		chart.render();
	}

	@ViewChild('confirmModal') confirmModal: TemplateRef<any>;
	private confirmModalRef: MatDialogRef<TemplateRef<any>>;
	openConfirmModal() {
		this.confirmModalRef = this.dialog.open(
			this.confirmModal, { disableClose: true }
		);
		this.confirmModalRef.afterClosed().subscribe((result) => {
			this.closeConfirmModal();
		});
	}

	closeConfirmModal() {
		this.confirmModalRef.close();
	}

	@Output() dataConfirmed = new EventEmitter<any>();
	confirmRecommendations() {
		this.commonService.getData('/confirmrecommendations/').subscribe(
			(res: any) => {
				this.user_details.is_book_optimized = true;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', 'Recommendation has been adjusted successfully.');
				this.closeConfirmModal();
				this.dataConfirmed.emit("Confirmed");
				this.getPageData();
			},
			(err) => {
				this.commonService.showToast('error', err.error.error);
			},
		);
	}

	@ViewChild('revertBackModal') revertBackModal: TemplateRef<any>;
	private revertBackModalRef: MatDialogRef<TemplateRef<any>>;
	openRevertBackModal() {
		this.revertBackModalRef = this.dialog.open(
			this.revertBackModal, { disableClose: true }
		);
		this.revertBackModalRef.afterClosed().subscribe((result) => {
			this.closeRevertBackModal();
		});
	}

	closeRevertBackModal() {
		this.revertBackModalRef.close();
	}

	revertBackRecommendations() {
		this.commonService.getData('/revertactualrecommendations/').subscribe(
			(res: any) => {
				this.user_details.is_book_optimized = false;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', 'Recommendation has been adjusted successfully.');
				this.closeRevertBackModal();
				this.dataConfirmed.emit("Confirmed");
				this.getPageData();
			},
			(err) => {
				this.commonService.showToast('error', err.error.error);
			},
		);
	}

	dataChanged(data) {
		this.getPageData();
	}

	description_sections: any = [
		{
		//   name: "This section provides AI recommendations on how to optimize your client book. It identifies which client segments advisors should focus on more, which segments can be handled by MAGI, and which clients can be reassigned to AFAs. These suggestions aim to increase wallet share and free up advisors' time, allowing them to concentrate on clients who need a more personalized experience.",
		name: "This section provides AI recommendations on how to optimize your client book. It identifies which client segments advisors should focus on more, which segments can be handled by MAGI, and which clients can be reassigned to Junior Advisors. These suggestions aim to increase wallet share and free up advisors' time, allowing them to concentrate on clients who need a more personalized experience.",
		  sub_sections: []
		},
	];

	summary_description_sections: any = [
		{
			name: "",
			  sub_sections: [
				{
					name: "Historical Rate of Growth",
					value: "The historical rate of growth is the percentage increase in a specific metric, such as revenue, client base, or AUM, over a defined past period. It is calculated by analyzing the growth trend over previous years or quarters to provide a historical perspective on growth patterns."
				},
				{
					name: "Predicted Rate of Growth",
					value: "The predicted rate of growth is the anticipated percentage increase in a specific metric, such as revenue, client base, or AUM, over a future period. This projection is typically based on historical data, market analysis, and statistical modeling."
				},
				{
					name: "Predicted Growth",
					value: "Predicted growth refers to the forecasted increase in a specific metric, expressed in absolute terms (e.g., dollars, number of clients) over a future period. It is derived from the predicted rate of growth."
				},
				{
					name: "Historical Rate of Attrition",
					value: "The historical rate of attrition is the percentage of clients or assets lost over a defined past period. It reflects the rate at which clients disengage or withdraw their assets, providing insight into past retention and attrition trends."
				},
				{
					name: "Predicted Rate of Attrition",
					value: "The predicted rate of attrition is the anticipated percentage of clients or assets expected to be lost over a future period. This forecast is based on historical data, client behavior analysis, and predictive modeling."
				},
				{
					name: "Predicted Loss",
					value: "Predicted loss refers to the forecasted decrease in a specific metric, such as the number of clients or the value of assets, over a future period. It is derived from the predicted rate of attrition and indicates potential future declines."
				},
				{
					name: "Client Engagement Score",
					value: "The client engagement score is a metric that quantifies the level of engagement and interaction a client has with a financial institution. It typically considers factors such as frequency of communication, transaction activity, and participation in offered services."
				},
				{
					name: "Number of Activities",
					value: "The number of activities refers to the total count of interactions, transactions, or engagements a client has with a financial institution over a defined period. This metric helps measure client activity levels and can include activities such as trades, account logins, meetings, and service requests."
				},
			  ]
			},
	];

	show_pdf_loader: boolean = false;
	@ViewChild('pdfDownloadSection', { static: false })
	pdfDownloadSection: ElementRef;
	@ViewChild('showPDFSection', { static: false }) showPDFSection: ElementRef;
	@ViewChild('hidePDFSection', { static: false }) hidePDFSection: ElementRef;

	generatePdfFromImage(data) {
		this.show_pdf_loader = true;

		this.hidePDFSection.nativeElement.style.display = 'none';
		this.showPDFSection.nativeElement.style.display = 'block';
		this.pdfDownloadSection.nativeElement.style.overflow = 'visible';

		setTimeout(() => {
			this.hidePDFSection.nativeElement.style.display = 'block';
			this.showPDFSection.nativeElement.style.display = 'none';
			this.pdfDownloadSection.nativeElement.style.display = 'auto';
		}, 100);

		html2canvas(data, {
			allowTaint: true,
			height: data.scrollHeight + 1000,
			width: data.scrollWidth,
		}).then((canvas) => {
			let HTML_Width = canvas.width;
			let HTML_Height = canvas.height;
			let top_left_margin = 100;
			let PDF_Width = HTML_Width + top_left_margin * 2;
			let PDF_Height = PDF_Width * 1.5 + top_left_margin * 2 + 50;
			let canvas_image_width = HTML_Width;
			let canvas_image_height = HTML_Height + 50;
			let totalPDFPages = Math.round(HTML_Height / PDF_Height) - 1;
			canvas.getContext('2d');
			let imgData = canvas.toDataURL('image/jpeg', 1.0);
			let pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
			pdf.addImage(
				imgData,
				'JPG',
				top_left_margin,
				top_left_margin,
				canvas_image_width,
				canvas_image_height,
			);
			for (let i = 1; i <= totalPDFPages; i++) {
				pdf.addPage([PDF_Width, PDF_Height], 'p');
				pdf.addImage(
					imgData,
					'JPG',
					top_left_margin,
					-(PDF_Height * i) + top_left_margin * 4,
					canvas_image_width,
					canvas_image_height,
				);
			}
			// pdf.output('dataurlnewwindow');
			if (this.page_type == "Performance") {
				// pdf.save('Advisor Performance Measurement.pdf');
				pdf.save('Advisor Scorecard.pdf');
			} else {
				pdf.save('Advisor Optimize Book.pdf');
			}

			this.show_pdf_loader = false;
		});
	}

}
